import { phoneFormat } from "../../lib/script"

import classes from './PhoneNumber.module.css'

const PhoneNumber = ({value, ext, isMobile}) => {
    return <div className={classes.container}>
        <a href={`tel:${value}${ext ? ","+ext : ''}`}>
            {phoneFormat(value)}
            {ext ? `, ext: ${ext}` : ''}
            {!isMobile && <i className="ti ti-phone"></i>}
            {isMobile && <i className="ti ti-device-mobile"></i>}
        </a>        
    </div>
}

export default PhoneNumber